import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
export class PositionToCmsModuleMap {}
let GetCmsModulesResponse = /*#__PURE__*/(() => {
  let GetCmsModulesResponse = class GetCmsModulesResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", PositionToCmsModuleMap)], GetCmsModulesResponse.prototype, "modules", void 0);
  GetCmsModulesResponse = __decorate([ModelId("GetCmsModulesResponse") // auto-generated by generate-model-ids
  ], GetCmsModulesResponse);
  return GetCmsModulesResponse;
})();
export { GetCmsModulesResponse };
let GetCmsModulesRequest = /*#__PURE__*/(() => {
  let GetCmsModulesRequest = class GetCmsModulesRequest extends Model {
    static {
      this.Response = GetCmsModulesResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], GetCmsModulesRequest.prototype, "path", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], GetCmsModulesRequest.prototype, "positions", void 0);
  GetCmsModulesRequest = __decorate([AppRequest('cms', 'get-modules', {
    httpMethod: AppRequestMethod.POST,
    clientCache: {
      seconds: 15 * 60
    }
  }), ModelId("GetCmsModulesRequest") // auto-generated by generate-model-ids
  ], GetCmsModulesRequest);
  return GetCmsModulesRequest;
})();
export { GetCmsModulesRequest };
let GetGlobalCmsModulesRequest = /*#__PURE__*/(() => {
  let GetGlobalCmsModulesRequest = class GetGlobalCmsModulesRequest extends Model {
    static {
      this.Response = GetCmsModulesResponse;
    }
  };
  GetGlobalCmsModulesRequest = __decorate([AppRequest('cms', 'get-global-modules', {
    httpMethod: AppRequestMethod.POST,
    clientCache: {
      seconds: 15 * 60
    }
  }), ModelId("GetGlobalCmsModulesRequest") // auto-generated by generate-model-ids
  ], GetGlobalCmsModulesRequest);
  return GetGlobalCmsModulesRequest;
})();
export { GetGlobalCmsModulesRequest };